import { defineMessages } from 'react-intl';

export default defineMessages({
	headline: {
		id: 'amex.headline',
		defaultMessage: 'Welcome to Calm',
		description: 'Headline text on the amex landing page',
	},
	subHeadline: {
		id: 'amex.subHeadline',
		defaultMessage:
			'Calm is the #1 app for Sleep, Meditation and Relaxation. Join the millions experiencing better sleep, lower stress, and less anxiety with our guided meditations, Sleep Stories, breathing programs, stretching exercises, and relaxing music.',
		description: 'SubHeadline text on the amex landing page',
	},
});
